import { useAuth } from 'hooks/useAuth';
import { FC, memo } from 'react';
import NoteCoder from './NoteCoder';
import NoteDocs from './NoteDocs';
import NoteManager from './NoteManger';

interface NoteDetailProps {
  notesData;
}

const NoteDetail: FC<NoteDetailProps> = ({ notesData }) => {
  const { CURRENT_ROLE } = useAuth();

  const renderDetail = () => {
    switch (CURRENT_ROLE) {
      case 'SYSTEM_ADMIN':
        return <NoteManager notesData={notesData} />;
        break;
      case 'DOCS':
        return <NoteDocs notesData={notesData} />;
        break;
      case 'CODERS':
        return <NoteCoder notesData={notesData} />;
        break;

      default:
        break;
    }
  };

  return <div className="flex-col text-xs">{renderDetail()}</div>;
};

export default memo(NoteDetail);
